import "./GhostButtonComponent.scss";
import template from "./GhostButtonComponent.html";
import {IComponentOptions} from "angular";

export const GhostButton = "tfGhostButton";

export function ghostButton(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: GhostButtonComponentController
    };
}

export class GhostButtonComponentController {

    /** @ngInject */
    public constructor() {

    }
}
